module.exports = __webpack_public_path__ + "img/서번트.58f839fc.png";